export default __webpack_public_path__ + "static/media/logo.6ce24c58.svg";